import { comicActionTypes as types } from 'src/redux/actions/comicActions';

const initialState = {
  loading: false,
  error: null,
  comics: {},
};

export default function comicReducer(state = initialState, { type, data, error, payload }) {
  switch (type) {
    case types.FETCH_COMICS_REQUEST:
    case types.ADD_COMIC_REQUEST:
    case types.EDIT_COMIC_REQUEST:
    case types.DELETE_COMICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case types.FETCH_COMICS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        comics: data
      }
    case types.ADD_COMIC_SUCCESS:
    case types.EDIT_COMIC_SUCCESS:
    case types.DELETE_COMICS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      }
    case types.FETCH_COMICS_FAILURE:
    case types.ADD_COMIC_FAILURE:
    case types.EDIT_COMIC_FAILURE:
    case types.DELETE_COMICS_FAILURE:
      return {
        ...state,
        loading: false,
        error
      }
    default:
      return state;
  }
}
